<div
  class="response-codes-bar"
  *ngIf="total > 0"
  [ngbTooltip]="responseCodesTooltip"
  tooltipClass="tooltip--nowrap response-codes-tooltip"
  container="body"
>
  <span
    class="response-codes-bar__bar bkg-color--green-500"
    [ngStyle]="{ width: successBarWidth + '%' }"
    >Success</span
  ><span
    class="response-codes-bar__bar bkg-color--grey-500"
    [ngStyle]="{ width: redirectionBarWidth + '%' }"
    >Redirection</span
  ><span
    class="response-codes-bar__bar bkg-color--orange-500"
    [ngStyle]="{ width: clientErrorBarWidth + '%' }"
    >Client error</span
  ><span
    class="response-codes-bar__bar bkg-color--red-500"
    [ngStyle]="{ width: serverErrorBarWidth + '%' }"
    >Server error</span
  ><!DOCTYPE html>
  <ng-template #responseCodesTooltip
    ><span class="response-codes-tooltip__text"
      >2xx<br /><span class="response-codes-tooltip__text-small">{{
        data.success | numberToHuman
      }}</span></span
    ><span class="response-codes-tooltip__text"
      >3xx<br /><span class="response-codes-tooltip__text-small">{{
        data.redirection | numberToHuman
      }}</span></span
    ><span class="response-codes-tooltip__text"
      >4xx<br /><span class="response-codes-tooltip__text-small">{{
        data.clientError | numberToHuman
      }}</span></span
    ><span class="response-codes-tooltip__text"
      >5xx<br /><span class="response-codes-tooltip__text-small">{{
        data.serverError | numberToHuman
      }}</span></span
    ></ng-template
  >
</div>
